import { TokenClaimDto } from '@tassat/common-definitions';
import { browserSessionStore } from '@tassat/utility';
import * as jwt from 'jsonwebtoken';

const tokenNamespace = 'https://wallet.truedgtl.com/';

export const getUserInfo = () => {
    let userId = '';
    let email = '';
    let username = '';

    // This feeds the global error-reporting pipeline (reportAppErrorEvent) - it must never itself
    // throw, or the error it was trying to report gets lost behind this one instead.
    let authToken: string | null = null;

    try {
        authToken = browserSessionStore.getItem('id_token');
    } catch (error) {
        console.error('Failed to read id_token while building error report user info', error);

        return;
    }

    const decodedToken = (jwt.decode(authToken as string) || {}) as TokenClaimDto;
    const authType = getAuthTypeFromToken(decodedToken);

    switch (authType) {
        case 'samlp':
            userId = browserSessionStore.getItem('userid') as string;
            username = decodedToken.sub;
            email = decodedToken[tokenNamespace].tpay_user_email;
            break;
        default:
            userId = browserSessionStore.getItem('userid') as string;
            email = decodedToken.email;
            username = decodedToken.username;
            break;
    }

    if (userId) {
        return {
            userId,
            email,
            username
        };
    }

    return;
};

const getAuthTypeFromToken = (authToken) => {
    if (!authToken || !authToken.sub) {
        return '';
    }

    const parts = authToken.sub.split(/\.|\||_/);

    return parts.length > 1 ? parts[0] : '';
};